// import React from "react";
// import { ArrowRight, ShieldCheck, TrendingUp } from "lucide-react";
// import rightImg from "../img/aaaservices/robo (2).jpg"; // apna image path yaha daalo
// import "./HeroSection.css";
// import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// export default function HeroSection() {
//     const navigate = useNavigate();
//   const stats = [
//     { value: "18,420+", label: "Learners placed" },
//     { value: "₹24.5 LPA", label: "Highest package" },
//     { value: "112%", label: "Average hike" },
//     { value: "640+", label: "Hiring partners" },
//   ];

//   return (
//     <section className="iia-hero">
//       <div className="iia-hero-container">
//         {/* Left column */}
//         <div className="iia-hero-left">
//           <span className="iia-hero-badge">
//             <ShieldCheck size={14} />
//             Industry Certified Training
//           </span>

//           <h1 className="iia-hero-heading">
//             Become the engineer that{" "}
//             <span className="iia-hero-heading-accent">
//               automates the factory floor.
//             </span>
//           </h1>

//           <p className="iia-hero-subtext">
//             Live PLC, SCADA, robotics and Industry 4.0 training built with
//             plant engineers — with real hardware labs, graded projects, and a
//             placement cell that has moved 18,420 learners into industry
//             roles.
//           </p>

//           <div className="iia-hero-actions">
//              <button
//       className="iia-hero-cta-primary"
//       onClick={() => navigate("/Secondactiveprograms")}
//     >
//       Explore Courses
//       <ArrowRight size={16} />
//     </button>
//             {/* <button
//   className="iia-hero-cta-secondary"
//   onClick={() =>
//     document.getElementById("placements")?.scrollIntoView({
//       behavior: "smooth",
//     })
//   }
// >
//   <TrendingUp size={16} />
//   View Placements
// </button> */}
//           </div>

//           <div className="iia-hero-stats">
//             {stats.map((s) => (
//               <div className="iia-hero-stat" key={s.label}>
//                 <div className="iia-hero-stat-value">{s.value}</div>
//                 <div className="iia-hero-stat-label">{s.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right column — Image */}
//         <div className="iia-hero-right">
//           <div className="iia-hero-image-wrap">
//             <div className="iia-hero-glow-blue" />
//             <div className="iia-hero-glow-orange" />

//             <div className="iia-hero-image-frame">
//               <img
//                 src={rightImg}
//                 alt="Automation training at IIA"
//                 className="iia-hero-image"
//               />
//             </div>

//             {/* <div className="iia-hero-floating-card">
//               <span className="iia-hero-live-dot" />
//               <div>
//                 <p className="iia-hero-floating-title">
//                   Live now · PID Tuning in Real Plants
//                 </p>
//                 <p className="iia-hero-floating-subtitle">
//                   186 learners · Dr. Kavita Rao
//                 </p>
//               </div>
//             </div> */}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }




import React, { useState, useEffect } from "react";
import { ArrowRight, ShieldCheck, TrendingUp, ChevronLeft, ChevronRight } from "lucide-react";
import rightImg1 from "../img/aaaservices/robo (2).jpg";
import rightImg2 from "../img/aaaservices/rea.webp";
import rightImg3 from "../img/aaaservices/scann-3d.jpg";
import rightImg4 from "../img/aaaservices/machine.png";
import "./HeroSection.css";


import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  // Image slider state
  const images = [rightImg1, rightImg2, rightImg3, rightImg4];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  // Manual navigation
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const stats = [
    { value: "18,420+", label: "Learners placed" },
    { value: "₹24.5 LPA", label: "Highest package" },
    { value: "112%", label: "Average hike" },
    { value: "640+", label: "Hiring partners" },
  ];

  return (
    <section className="iia-hero">
      <div className="iia-hero-container">
        {/* Left column */}
        <div className="iia-hero-left">
          <span className="iia-hero-badge">
            <ShieldCheck size={14} />
            Industry Certified Training
          </span>

          <h1 className="iia-hero-heading">
            Become the engineer that{" "}
            <span className="iia-hero-heading-accent">
              automates the factory floor.
            </span>
          </h1>

          <p className="iia-hero-subtext">
            Live PLC, SCADA, robotics and Industry 4.0 training built with
            plant engineers — with real hardware labs, graded projects, and a
            placement cell that has moved 18,420 learners into industry
            roles.
          </p>

          <div className="iia-hero-actions">
            <button
              className="iia-hero-cta-primary"
              onClick={() => navigate("/Secondactiveprograms")}
            >
              Explore Courses
              <ArrowRight size={16} />
            </button>
          </div>

          <div className="iia-hero-stats">
            {stats.map((s) => (
              <div className="iia-hero-stat" key={s.label}>
                <div className="iia-hero-stat-value">{s.value}</div>
                <div className="iia-hero-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column — Image Slider */}
        <div className="iia-hero-right">
          <div className="iia-hero-image-wrap">
            <div className="iia-hero-image-frame">
              {/* Slide images */}
              <div className="slider-container">
                <div
                  className="slider-track"
                  style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                  {images.map((img, index) => (
                    <div key={index} className="slider-slide">
                      <img
                        src={img}
                        alt={`Automation training at IIA ${index + 1}`}
                        className="iia-hero-image"
                      />
                    </div>
                  ))}
                </div>

                {/* Navigation Arrows */}
                {/* <button className="slider-arrow slider-arrow-left" onClick={goToPrevious}>
                  <ChevronLeft size={24} />
                </button>
                <button className="slider-arrow slider-arrow-right" onClick={goToNext}>
                  <ChevronRight size={24} />
                </button> */}

                {/* Dots Indicator */}
                {/* <div className="slider-dots">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`slider-dot ${index === currentIndex ? "active-dot" : ""}`}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}